export class CertificadoMilitar {
  Numero: string;
  Csm: string;
  Serie: string;
}
